import {
  NOTIFICATION_LIST,
  NOTIFICATION_SETTINGS,
  MARK_ALL_NOTIFICATION_READ,
  MARK_NOTIFICATION_READ,
  NOTIFICATION_META_CONFIG,
  NOTIFICATION_UNREAD_COUNT
} from "../../constants/apis";
import { getUrl, replaceMultiple } from "../../utilities/helpers";

export const fetchNotificationSettings =
  (uuid, query) =>
  (dispatch, getState, { apiReport }) => {
    const finalUrlPath = replaceMultiple(NOTIFICATION_SETTINGS, {
      "{{uuid}}": uuid,
    });
    const url = getUrl(finalUrlPath, query);
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const updateNotificationSettings =
  (uuid, payload) =>
  (dispatch, getState, { apiReport }) => {
    const url = replaceMultiple(NOTIFICATION_SETTINGS, {
      "{{uuid}}": uuid,
    });
    return apiReport
      .put(url, payload)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const getNotificationList =
  (filters) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(NOTIFICATION_LIST, filters);
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const getNotificationMetaConfig =
  (filters) =>
  (dispatch, getState, { apiReport }) => {
    return apiReport
      .get(NOTIFICATION_META_CONFIG)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const markNotificationRead =
  (uuid) =>
  (dispatch, getState, { apiReport }) => {
    const url = replaceMultiple(MARK_NOTIFICATION_READ, {
      ":notification_uuid": uuid,
    });
    
    return apiReport
      .put(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const markAllNotificationRead =
  () =>
  (dispatch, getState, { apiReport }) => {
    return apiReport
      .put(MARK_ALL_NOTIFICATION_READ)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

  export const getNotificationUnreadCount  =
  () =>
  (dispatch, getState, { apiReport }) => {
    return apiReport
      .get(NOTIFICATION_UNREAD_COUNT)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };


